import gql from 'graphql-tag';

const MUTATION_DELETE_FILE = gql`
	mutation DeleteFile($fileID: String!, $folderID: String!) {
		deleteFile(fileID: $fileID, folderID: $folderID)
	}
`;

export default MUTATION_DELETE_FILE;